import React, { useEffect, useState } from "react";
import styled from "styled-components";

interface PaginationProps {
  totalPage: number;
  currentPage: number;
  pageClickEvent: (a: number) => void;
  pageSize?: number;
  totalCount?: number;
}

interface SPageText {
  isActivate: boolean;
}

export default function Pagination({
  totalPage,
  currentPage,
  pageClickEvent,
}: PaginationProps) {
  const originPageArray = Array.from({ length: totalPage }, (_, i) => i);

  const [sliceStart, setSliceStart] = useState(0);
  const [sliceEnd, setSliceEnd] = useState(totalPage > 10 ? 10 : totalPage);
  const [pageList, setPageList] = useState(
    originPageArray.slice(sliceStart, sliceEnd)
  );

  useEffect(() => {
    setPageList(originPageArray.slice(sliceStart, sliceEnd));
  }, [sliceStart, sliceEnd]);

  useEffect(() => {
    setSliceEnd(totalPage > 10 ? 10 : totalPage);
  }, [totalPage]);

  return (
    <PaginationContainer>
      <Arrow
        onClick={() => {
          if (currentPage !== 0) {
            pageClickEvent(currentPage - 1);

            if (currentPage % 10 === 0) {
              setSliceStart((prev) => prev - 10);
              setSliceEnd((prev) => prev - 10);
            }
          }
        }}
        disabled={currentPage === 0}
      >
        <span className="material-icons">chevron_left</span>
      </Arrow>

      {pageList?.map((p, index: number) => {
        return (
          <Page onClick={() => pageClickEvent(p)} key={p}>
            <PageText isActivate={currentPage === p}>{p + 1}</PageText>
          </Page>
        );
      })}

      <Arrow
        onClick={() => {
          if (currentPage + 1 !== totalPage) {
            pageClickEvent(currentPage + 1);

            if (currentPage % 10 === 9) {
              setSliceStart((prev) => prev + 10);
              setSliceEnd((prev) => prev + 10);
            }
          }
        }}
        disabled={currentPage + 1 === totalPage || totalPage === 0}
      >
        <span className="material-icons">chevron_right</span>
      </Arrow>
    </PaginationContainer>
  );
}

const PaginationContainer = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
`;

const Arrow = styled.button`
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    cursor: not-allowed;
    span {
      color: ${({ theme }) => theme.buttonColor.lineDisabled};
    }
  }

  span {
    width: 20px;
    height: 20px;
    font-size: 18px;
    color: #858c97;
  }

  &:first-child {
    margin-right: 8px;
  }

  &:last-child {
    margin-left: 6px;
  }
`;

const Page = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:not(:last-child) {
    margin-right: 2px;
  }
`;

const PageText = styled.span<SPageText>`
  font-size: 15px;
  font-weight: ${({ isActivate }) => (isActivate ? 700 : 500)};
  line-height: 22.5px;
  text-align: center;
  color: ${({ isActivate }) => (isActivate ? "#00beb0" : "#9a9fa8")};
`;
